export default __webpack_public_path__ + "static/media/admin_product_customer.362d2d8a.svg";